export enum ViewType {
    Box = 1,
    Workflow = 2,
    ArchivingBox = 3,
    ArchivingWorkflow = 4,
}
